const columns = [
  {
    title: '内容频道',
    links: ['负面新闻', '丑闻曝光', '翻车记录', '黑料新进展'],
  },
  {
    title: '追踪工具',
    links: ['爆料追踪线索', '事件时间线', '热搜追踪榜', '话题标签云'],
  },
  {
    title: '关于本站',
    links: ['内容说明', '信息来源', '纠错与反馈', '联系我们'],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-950 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 pt-12 md:pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="flex items-center justify-center w-9 h-9 rounded-md bg-primary-600 text-background-50 font-heading text-lg font-bold">
                18
              </span>
              <span className="font-heading text-[22px] font-bold text-background-50">黑料网</span>
            </div>
            <p className="mt-4 text-[13px] leading-relaxed text-background-300 max-w-[420px]">
              18黑料网聚合全网负面新闻、丑闻曝光与翻车记录，按时间线整理黑料新进展与爆料追踪线索，帮你看清热点人物的事件脉络。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {['ri-weibo-line', 'ri-wechat-line', 'ri-mail-line', 'ri-rss-line'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/10 border border-background-50/15 text-background-200 hover:bg-background-50/20 transition-colors"
                >
                  <i className={`${icon} text-[16px]`} />
                </a>
              ))}
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <h4 className="text-[13px] font-semibold text-background-50 mb-4">
                <a href="#top" className="hover:text-accent-400 transition-colors">
                  {col.title}
                </a>
              </h4>
              <ul className="flex flex-col gap-3">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#latest"
                      className="text-[13px] text-background-300 hover:text-background-50 transition-colors"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-[12px] leading-relaxed text-background-400 max-w-[720px]">
            本站内容均为网络公开信息的转载与时序整理，相关当事方回应以官方声明为准。若内容存在失实或侵权，请联系我们处理。
          </p>
          <p className="text-[12px] text-background-400 whitespace-nowrap">
            © 2026 18黑料网 · 仅供演示
          </p>
        </div>
      </div>
    </footer>
  );
}